export const address = '0x18c17ccdd71d547e966b7422252fd8834f6b9902'
export const abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: 'abiKey',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'recharge',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  }
]

// ABI 编码映射
export const abiMap = {
  super_consensus:
    '[{"internalType": "address", "name": "tokenAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  game_node:
    '[{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  game_pledge:
    '[{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  recharge:
    '[{"internalType": "address", "name": "tokenAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]',
  peer_receive:
    '[{"internalType": "address", "name": "tokenAddress", "type": "address"},{"internalType": "uint256", "name": "amount", "type": "uint256"},{"internalType": "string", "name": "remark", "type": "string"}]'
}
